import "./assets/main.css";

import { createApp } from "vue";

import router from "./router";

import { pinia } from "./stores/pinia";
import App from "./App.vue";
import VueGtag from "vue-gtag";

// Vuetify
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import VueHcaptcha from "@hcaptcha/vue3-hcaptcha";
import VueApexCharts from "vue3-apexcharts";

import authService from '@/services/auth';


const vuetify = createVuetify({
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: "light",
  },
  components,
  directives,
});

const app = createApp(App);

app.config.globalProperties.$filters = {

  toDecimal(value) {
    return parseFloat(value).toFixed(2);
  },

  toGenericCurrency(value) {
    return parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  },

  formattedNumber(value) {
    if (value === undefined) {
      value = 0
    }
    return value.toLocaleString("en-US", {});
  },



  currencyUSD(value) {
    if (value === undefined) {
      value = 0
    }
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  },

  toCurrency(value, currencyCode) {
    if (value === undefined) {
      value = 0
    }
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: currencyCode,
    });
  },

  toNiceDate(value) {
    if (value == null) {
      return '';
    }
    return new Date(value).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: 'numeric'
    });
  },


};


app.component("VueHcaptcha", VueHcaptcha);
app.use(VueApexCharts);
app.use(pinia);
app.use(router);
app.use(vuetify);
app.use(VueGtag, {
  appName: 'RISE Portal',
  // pageTrackerScreenviewEnabled: true,
  pageTrackerTemplate(to) {
    return {
      page_title: to.name,
      page_path: to.path
    }
  },
  config: {
    id: "G-0T3LM339QN",
  },
}, router)
app.use(VueApexCharts);
app.mount("#app");
